const percentFormatter = new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 1 });

export const calculateMarginPercent = (profit, sellingPrice) =>
  Number.isFinite(profit) && Number.isFinite(sellingPrice) && sellingPrice > 0
    ? (profit / sellingPrice) * 100
    : null;

export const formatMarginPercent = percent => {
  if (percent == null || !Number.isFinite(percent)) return '—';
  // A small loss rounded to one decimal place should not display as "-0%".
  return `${percentFormatter.format(Math.abs(percent) < 0.05 ? 0 : percent)}%`;
};
